<template>
  <v-layout class="" column wrap style="overflow: hidden;">
    <v-toolbar dark class="toolbarcreatedadmin" style="margin-top: 20px;">
      <v-btn icon @click="previousPage()">
        <v-icon>fas fa-chevron-left</v-icon>
      </v-btn>
      <img :src="BASE_URL + 'static/icon/heart.svg'" alt="" width="40px"> &nbsp;&nbsp;
      <v-toolbar-title>ข้อมูลเครื่อง AED</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">
        <v-text-field
          hide-details
          solo
          v-model="search"
          append-icon="search"
          label="ค้นหาจากเจ้าของ สถานที่ หรือS/N"
          class="textfieldSearch"
        ></v-text-field>
         <v-select
          :items="itemsselect"
          v-model="selectKey"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          class="textfieldSelect kanit"
        ></v-select>
      </div>
    </v-toolbar>
    <div class="hidden-md-and-up">
      <v-text-field
        hide-details
        solo
        v-model="search"
        append-icon="search"
        label="ค้นหาจากเจ้าของ สถานที่ หรือS/N"
        class="textfieldSearch"
      ></v-text-field>
      <v-select
        :items="itemsselect"
        v-model="selectKey"
        item-text="text"
        item-value="value"
        solo
        hide-details
        ligth
        class="textfieldSelect"
      ></v-select>
    </div>
    <v-layout class="pb-4" row wrap justify-center align-center style="margin-top: 20px; width: 100%; overflow-x: auto;">
      <v-data-table
        :headers="headers"
        :items="listAED"
        :items-per-page="limit"
        :loading="table_loading"
        hide-default-footer
        fixed-header
        class="elevation-1 mx-4 data-table-container"
        @click:row="selectedDetailAED"
        style="cursor: pointer; width: 100%;"
        height="450px"
      >
        <template v-slot:item.address_name="{ item }">
          📍 {{item.address_name}}
        </template> 
        <template v-slot:item.company_owner_name="{ item }">
          {{(item.company_owner_name)? item.company_owner_name:'-'}}
        </template> 
        <template v-slot:item.company_maintenance_name="{ item }">
          {{(item.company_maintenance_name)? item.company_maintenance_name:'-'}}
        </template> 
        <template v-slot:item.create_at="{ item }">
          {{ dateMoment(item.create_at)}} - {{ timeMoment(item.create_at)}}น.
        </template>
        <template v-slot:item.who_add_aed="{ item }">
          {{ (item.who_add_aed == '')? '-':item.who_add_aed }}
        </template>
        <template v-slot:item.serial_number="{ item }">
          {{ (item.serial_number)? item.serial_number:'-' }}
        </template>
        <template v-slot:loading>
          <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
        </template>
      </v-data-table>
     <v-pagination color="#a81000" v-model="page_pagination" :total-visible="7" :length="total_page"></v-pagination>
    </v-layout>
  </v-layout>
</template>
<script>
var _ = require('lodash')
import { Decode, Momenttime } from '@/services'
export default {
  data () {
    return {
    BASE_URL: process.env.BASE_URL,
    items: [],
    selectKey: this.$route.query.typeSearch,
    itemsselect: [
      { text: 'ทั้งหมด', value: 'all' },
      { text: 'สภากาชาด', value: 'redcross' },
      { text: 'อื่นๆ', value: 'other' },
      { text: 'แบตเตอร์รี่หมดอายุแล้ว', value: 'battery_expire' },
      { text: 'แพดหมดอายุแล้ว', value: 'pad_expire' }
    ],
    search: '',
    headers: [
      { text: 'สถานที่', value: 'address_name' },
      { text: 'เจ้าของ', value: 'company_owner_name' ,filterable: true},
      { text: 'หน่วยงานที่ดูแล', value: 'company_maintenance_name' },
      { text: 'Serial Number', value: 'serial_number' },
      { text: 'วันเวลาที่สร้าง', value: 'create_at' },
      { text: 'Pad expire', value: 'pad_expire' },
      { text: 'Battery expire', value: 'battery_expire' }
    ],
    listAED: [],
    typeCompany: 'partner',
    page_pagination: 1,
    limit: 10,
    total_page: 0,
    dialogshow_historyDetail: false,
    table_loading: false
  }},
  watch: {
    page_pagination () {
      window.history.replaceState(null, null, "?typeSearch=" + this.selectKey + "&page=" + this.page_pagination + "&search=" + this.search)
      this.getlistAED()
    },
    selectKey () {
      this.page_pagination = 1
      this.getlistAED()
      window.history.replaceState(null, null, "?typeSearch=" + this.selectKey + "&page=" + this.page_pagination + "&search=" + this.search)
    },
    search () {
      this.page_pagination = 1
      this.getlistAED()
      window.history.replaceState(null, null, "?typeSearch=" + this.selectKey + "&page=" + this.page_pagination + "&search=" + this.search)
    }
  },
  created () {
    this.typeCompany = this.$store.state.key_object.typeCompany
    this.page_pagination = parseInt(this.$route.query.page)
    this.getlistAED()
    // if (this.$route.query.typeSearch == 'all' || this.$route.query.typeSearch == 'redcross' || this.$route.query.typeSearch == 'other') {
    //   this.selectKey = this.$route.query.typeSearch
    // }
  },
  computed: {
    // listAEDFile () {
    //   if (this.search !== '' && this.search !== null) {
    //     return this.listAEDMode.filter(post => {
    //       try {
    //         // console.log(post.address_name)
    //         return ((post.company_owner_name!=null)? post.company_owner_name.toLowerCase().includes(this.search.toLowerCase()):false) || ((post.company_maintenance_name!=null)? post.company_maintenance_name.toLowerCase().includes(this.search.toLowerCase()):false) || post.address_name.toLowerCase().includes(this.search.toLowerCase()) || post.serial_number.toLowerCase().includes(this.search.toLowerCase())
    //       } catch(err) {
    //       }
    //     })
    //   } else {
    //     return this.listAEDMode
    //   }
    // },
    // listAEDMode () {
    //   if (this.selectKey == 'redcross') {
    //     return _.reject(this.listAED, ['is_create_by_company_type_owner', false])
    //   } else if (this.selectKey == 'other') {
    //     return _.reject(this.listAED, ['is_create_by_company_type_owner', true])
    //   } else if (this.selectKey == 'battery_expire') {
    //     var now = moment().format('DD/MM/YYYY')
    //     return _.filter(this.listAED, function (member) { 
    //       return member.battery_expire !== '' && member.battery_expire !== null && moment(now, 'DD/MM/YYYY').isAfter(moment('01/' + member.battery_expire, 'DD/MM/YYYY'))})
    //   } else if (this.selectKey == 'pad_expire') {
    //     var now = moment().format('DD/MM/YYYY')
    //     return _.filter(this.listAED, function (member) { 
    //       return member.pad_expire !== '' && member.pad_expire !== null && moment(now, 'DD/MM/YYYY').isAfter(moment('01/' + member.pad_expire, 'DD/MM/YYYY'))})
    //   } else {
    //     return this.listAED
    //   }
    // }
  },
  methods: {
    selectedDetailAED (item, row) {
      this.$router.push('/information_aed?id='+item.aed_id)
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    getlistAED () {
      // console.log(this.headerAPI)
      // this.axios.post(process.env.API_BACKEND + '/v1/getAllAedInDetailForSuperAdmin', {}, {headers: this.headerAPI}).then((response) => {
      //   this.listAED = response.data.data
      //   this.listAED = _.sortBy(this.listAED, function(dateObj) {
      //     return new Date(dateObj.create_at)
      //   }).reverse()
      // })
      this.table_loading = true
      var textparams = '?page='+this.page_pagination + '&limit='+this.limit+ '&filter='+this.selectKey + '&search='+this.search 
      this.$api.getlistAED(textparams).then((response) => {
        this.listAED = response.data.list_item
        // this.listAED = _.sortBy(this.listAED, function(dateObj) {
        //   return new Date(dateObj.create_at)
        // }).reverse()
        this.total_page = response.data.total_page
        this.table_loading = false
        // console.log(reverse.data)
      })
    },
    previousPage () {
      // this.$router.back()
      this.$router.push('/homepage')
    }
  }
}
</script>
<style media="screen" scoped>

>>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.theme--dark.v-select .v-select__selections {
    color: #a80e00 !important;
}
>>>.theme--dark.v-label {
    color: hsl(5, 100%, 33%) !important;
}
>>>.theme--dark.v-icon {
    color: #a80e00 !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
  color: #a80e00 !important;
}
>>>.v-select__selections {
  line-height: 26px !important;
}
>>>.v-select__selection--comma {
  color: #a80e00 !important;
}
>>>.v-input .v-label {
    height: 26px;
    line-height: 26px;
  }
>>>.v-list-item__title {
    line-height: 26px !important;
}
.toolbarcreatedadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}

/* >>>.v-input__slot {
  border-radius: 10px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: #a80f00 !important;
  background-color: #a80d0021 !important;
} */
.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btncreateuser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btncreateuser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}

>>>.theme--light.v-data-table thead tr:last-child th {
    border-bottom: thin solid rgba(0,0,0,.12);
    background: #a80e00 !important;
    color: white !important;
}
>>>.v-data-table__wrapper {
    border-radius: 14px;
}

>>>.theme--light.v-data-table {
    border-radius: 14px !important;
    margin-bottom: 20px !important;
}

.textfieldSearch {
  width: 330px;
  display: -webkit-inline-box;
  margin-right: 20px;
}

.textfieldSelect {
  width: 200px;
  display: -webkit-inline-box;
  margin-right: 20px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .textfieldSearch {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .textfieldSelect {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
     border-radius: 30px !important;
    background: #ffffff !important;
    color: #a80e00 !important;
    border-color: #a80e00 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

}

>>>.primary {
    background-color: #a81000 !important;
    border-color: #a81000 !important;
}

>>>.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #ffe6e6 !important;
    cursor: pointer;
}
>>>.v-data-table-header-mobile{
        display: none !important;
      }

>>>.v-application .primary {
    background-color: #a81000 !important;
    border-color: #a81000 !important;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>> .v-list-item__title {
  line-height: 26px !important;
  font-family: 'Kanit', sans-serif !important;
}
/* >>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/listReport/Listaed.vue